import type { TimelineEventTypes } from '@ViewModels';
import { ITimelineFilterOption } from '../../../web/components/entities/EntityTimeline/TimelineFilter';

// A 'skips' (SkipLeadEvent) option is deliberately absent: showing skips biases reps on a later serving of
// the same lead. Reinstating it should come with an account preference under features.aida.
//
// File events cannot be offered here. This view reads the company timeline, which matches events by company
// id, and every file event references contact ids only — so no file event can ever appear. FileSendEvent is
// not even on that endpoint's typeOf allowlist, and the API rejects the whole request when any requested
// type is missing from it, which took the entire timeline down rather than just emptying one filter.
export const ENGAGEMENT_FILTER_OPTIONS: ITimelineFilterOption[] = [
	{ id: 'notes', name: 'notes', label: 'Show notes', types: ['NoteEvent'] },
	{ id: 'emails', name: 'emails', label: 'Show emails', types: ['SentEmailEvent'] },
	{ id: 'meetings', name: 'meetings', label: 'Show meetings', types: ['MeetingEvent'] },
	{ id: 'deals', name: 'deals', label: 'Show deals', types: ['DealCreatedEvent', 'DealUpdatedEvent'] },
	{
		id: 'phone-calls',
		name: 'phone calls',
		label: 'Show phone calls',
		types: ['PhoneCallEvent', 'PhoneCallCompletedEvent', 'UntrackedPhoneCallEvent'],
	},
	{
		id: 'follow-ups',
		name: 'follow ups',
		label: 'Show follow ups',
		types: ['FollowUpEvent', 'CancelledFollowUpEvent', 'RescheduledFollowUpEvent'],
	},
];

export const allEventNames = ENGAGEMENT_FILTER_OPTIONS.flatMap(option => option.types) as TimelineEventTypes[];

export const allEngagementFilterIds = ENGAGEMENT_FILTER_OPTIONS.map(option => option.id);
